module.exports = __webpack_public_path__ + "static/media/Shelgon_gaussian2.c56e037b.png";